// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-specific styles */
.App {
    min-height: 100vh;
}

/* Sidebar */
.sidebar {
    position: fixed;
    left: 0px;
    top: 0px;
    min-height: 100vh;
    width: 16rem;
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
    --tw-gradient-from: #1a0a2e var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(26 10 46 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
    --tw-gradient-stops: var(--tw-gradient-from), #2d1b4e var(--tw-gradient-via-position), var(--tw-gradient-to);
    --tw-gradient-to: #1a0a2e var(--tw-gradient-to-position);
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@supports (color: rgb(0 0 0 / 0)) {
.sidebar {
        --tw-gradient-to: rgb(45 27 78 / 0)  var(--tw-gradient-to-position);
    }
}

.sidebar-link {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border-radius: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    color: rgb(255 255 255 / 0.7);
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

.sidebar-link:hover {
    background-color: rgb(255 255 255 / 0.1);
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.sidebar-link.active {
    --tw-bg-opacity: 1;
    background-color: rgb(242 101 34 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    box-shadow: 0 4px 15px rgba(242, 101, 34, 0.3);
}

/* Main content */
.main-content {
    margin-left: 16rem;
    min-height: 100vh;
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

/* Header (page subheader; sits below global SiteHeader) */
.header {
    position: sticky;
    top: 4rem;
    z-index: 10;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.dark .main-content > div > .header,
.dark .main-content .header:not(.leaflet-container *) {
    background-color: #1E293B;
}
.dark .main-content .header { border-color: #334155; }

/* KPI cards */
.kpi-card {
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.25rem;
    transition-property: box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.dark .main-content > div > .kpi-card,
.dark .main-content .kpi-card:not(.leaflet-container *) {
    background-color: #1E293B;
}
.dark .main-content .kpi-card { border-color: #334155; }
.kpi-card:hover {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.kpi-value {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.kpi-label {
    margin-top: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

/* Chart containers */
.chart-container {
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.5rem;
}
.dark .main-content > div > .chart-container,
.dark .main-content .chart-container:not(.leaflet-container *) {
    background-color: #1E293B;
}
.dark .main-content .chart-container { border-color: #334155; }

/* Badge styles */
.badge {
    display: inline-flex;
    align-items: center;
    border-radius: 9999px;
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 500;
}

/* Trend indicators */
.trend-up {
    --tw-text-opacity: 1;
    color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}

.trend-down {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.trend-neutral {
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

/* Table responsive */
.table-responsive {
    overflow-x: auto;
}

/* Filter pills */
.filter-pill {
    cursor: pointer;
    border-radius: 9999px;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

.filter-pill.active {
    --tw-bg-opacity: 1;
    background-color: rgb(242 101 34 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.filter-pill:not(.active) {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.filter-pill:not(.active):hover {
    --tw-bg-opacity: 1;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

/* Score circles */
.score-circle {
    display: flex;
    height: 3rem;
    width: 3rem;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* Alert cards */
.alert-card {
    margin-bottom: 0.75rem;
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem;
}
.dark .main-content > div > .alert-card,
.dark .main-content .alert-card:not(.leaflet-container *) {
    background-color: #1E293B;
}
.dark .main-content .alert-card { border-color: #334155; }

.alert-card.critical {
    border-left-width: 4px;
    --tw-border-opacity: 1;
    border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.alert-card.high {
    border-left-width: 4px;
    --tw-border-opacity: 1;
    border-left-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}

.alert-card.medium {
    border-left-width: 4px;
    --tw-border-opacity: 1;
    border-left-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}

.alert-card.low {
    border-left-width: 4px;
    --tw-border-opacity: 1;
    border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

/* Role card styles */
.role-card {
    cursor: pointer;
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.5rem;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
    animation-duration: 200ms;
}
.dark .main-content > div > .role-card,
.dark .main-content .role-card:not(.leaflet-container *) {
    background-color: #1E293B;
}
.dark .main-content .role-card { border-color: #334155; }

.role-card:hover {
    --tw-border-opacity: 1;
    border-color: rgb(242 101 34 / var(--tw-border-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transform: translateY(-4px);
}

.role-card.selected {
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(242 101 34 / var(--tw-border-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Pillar cards */
.pillar-card {
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.5rem;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.dark .main-content > div > .pillar-card,
.dark .main-content .pillar-card:not(.leaflet-container *) {
    background-color: #1E293B;
}
.dark .main-content .pillar-card { border-color: #334155; }
.pillar-card:hover {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transform: translateY(-2px);
}

/* Status badges */
.status-on-track {
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}

.status-at-risk {
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}

.status-delayed {
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.status-planned {
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

/* Progress bar custom */
.progress-saffron {
    background: linear-gradient(90deg, #F26522 0%, #FF8A50 100%);
}

.progress-blue {
    background: linear-gradient(90deg, #1E3A8A 0%, #3B82F6 100%);
}

/* Data table styling */
.data-table {
    width: 100%;
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.data-table th {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    text-align: left;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    --tw-text-opacity: 1;
    color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.dark .main-content .data-table th { border-color: #334155; }

.data-table td {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}

.dark .main-content .data-table td { border-color: #334155; }

.data-table tbody tr:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

/* Alert severity badges */
.severity-critical {
    --tw-bg-opacity: 1;
    background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.severity-high {
    --tw-bg-opacity: 1;
    background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.severity-medium {
    --tw-bg-opacity: 1;
    background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.severity-low {
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* Glass card effect */
.glass-card {
    border-radius: 0.75rem;
    border-width: 1px;
    border-color: rgb(255 255 255 / 0.2);
    background-color: rgb(255 255 255 / 0.8);
    --tw-backdrop-blur: blur(16px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

/* Gradient text */
.gradient-text {
    background: linear-gradient(135deg, #F26522 0%, #FF8A50 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* Leaflet map overrides */
.district-tooltip {
    background: white !important;
    border: 1px solid #E2E8F0 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
    padding: 8px 12px !important;
}

.district-tooltip::before {
    border-top-color: #E2E8F0 !important;
}

.leaflet-container {
    font-family: 'Outfit', sans-serif;
    background: #FFFFFF !important;
}

.leaflet-control-zoom a {
    color: #1E3A8A !important;
    border-color: #E2E8F0 !important;
}

.leaflet-control-zoom a:hover {
    background-color: #F8FAFC !important;
}

/* District label and star marker styling */
.district-label-icon {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

.star-marker {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

/* ============ DARK MODE ============ */
.dark .main-content {
    --tw-bg-opacity: 1;
    background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.dark .header {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark .header h1,
.dark .main-content h1,
.dark .main-content h2,
.dark .main-content h3,
.dark .main-content h4 {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark .header p,
.dark .kpi-label {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.dark .kpi-card {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark .kpi-value {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark .chart-container {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark .data-table th {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark .data-table td {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark .data-table tbody tr:hover {
    background-color: rgb(51 65 85 / 0.5);
}

.dark .role-card {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark .pillar-card {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark .pillar-card p, .dark .pillar-card span {
    --tw-text-opacity: 1;
    color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark .alert-card {
    --tw-border-opacity: 1;
    border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark .glass-card {
    border-color: rgb(51 65 85 / 0.5);
    background-color: rgb(30 41 59 / 0.8);
}

.dark .filter-pill:not(.active) {
    --tw-bg-opacity: 1;
    background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark .filter-pill:not(.active):hover {
    --tw-bg-opacity: 1;
    background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}

/* Dark text overrides for main content area */
.dark .main-content [class*="text-slate-900"] { color: #F8FAFC; }
.dark .main-content [class*="text-slate-800"] { color: #F1F5F9; }
.dark .main-content [class*="text-slate-700"] { color: #CBD5E1; }
.dark .main-content [class*="text-slate-600"] { color: #94A3B8; }
.dark .main-content [class*="text-slate-500"] { color: #94A3B8; }

.dark .main-content > div > .bg-white,
.dark .main-content .bg-white:not(.leaflet-container *) {
    background-color: #1E293B;
}

.dark .main-content .border-slate-200 { border-color: #334155; }
.dark .main-content .border-slate-100 { border-color: #334155; }

/* Dark mode for leaflet */
.dark .leaflet-container {
    background: #0F172A !important;
}

.dark .district-tooltip {
    background: #1E293B !important;
    border-color: #334155 !important;
    color: #E2E8F0 !important;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,iBAAiB;AACrB;;AAEA,YAAY;AAER;IAAA,eAAiH;IAAjH,SAAiH;IAAjH,QAAiH;IAAjH,iBAAiH;IAAjH,YAAiH;IAAjH,sEAAiH;IAAjH,4DAAiH;IAAjH,kEAAiH;IAAjH,mEAAiH;IAAjH,4GAAiH;IAAjH,wDAAiH;IAAjH,oBAAiH;IAAjH;AAAiH;AAAjH;AAAA;QAAA;IAAiH;AAAA;;AAIjH;IAAA,aAAsH;IAAtH,mBAAsH;IAAtH,YAAsH;IAAtH,sBAAsH;IAAtH,kBAAsH;IAAtH,mBAAsH;IAAtH,oBAAsH;IAAtH,uBAAsH;IAAtH,6BAAsH;IAAtH,+FAAsH;IAAtH,wDAAsH;IAAtH;AAAsH;;AAAtH;IAAA,wCAAsH;IAAtH,oBAAsH;IAAtH;AAAsH;;AAItH;IAAA,kBAAwC;IAAxC,2DAAwC;IAAxC,oBAAwC;IAAxC,mDAAwC;IAAxC,+EAAwC;IAAxC,mGAAwC;IAAxC,uGAAwC;IACxC;AADwC;;AAI5C,iBAAiB;AAEb;IAAA,kBAAqC;IAArC,iBAAqC;IAArC,kBAAqC;IAArC;AAAqC;;AAGzC,0DAA0D;AAEtD;IAAA,gBAAsE;IAAtE,SAAsE;IAAtE,WAAsE;IAAtE,wBAAsE;IAAtE,sBAAsE;IAAtE,4DAAsE;IAAtE,kBAAsE;IAAtE,4DAAsE;IAAtE,oBAAsE;IAAtE,qBAAsE;IAAtE,iBAAsE;IAAtE;AAAsE;AAAtE;;IAAA,yBAAsE;AAAA;AAAtE,8BAAA,qBAAsE,EAAA;;AAG1E,cAAc;AAEV;IAAA,sBAAwF;IAAxF,iBAAwF;IAAxF,sBAAwF;IAAxF,4DAAwF;IAAxF,kBAAwF;IAAxF,4DAAwF;IAAxF,gBAAwF;IAAxF,+BAAwF;IAAxF,wDAAwF;IAAxF;AAAwF;AAAxF;;IAAA,yBAAwF;AAAA;AAAxF,gCAAA,qBAAwF,EAAA;AAAxF;IAAA,6EAAwF;IAAxF,iGAAwF;IAAxF;AAAwF;;AAIxF;IAAA,iBAAwC;IAAxC,iBAAwC;IAAxC,gBAAwC;IAAxC,oBAAwC;IAAxC;AAAwC;;AAIxC;IAAA,mBAAkC;IAAlC,mBAAkC;IAAlC,oBAAkC;IAAlC,oBAAkC;IAAlC;AAAkC;;AAGtC,qBAAqB;AAEjB;IAAA,sBAAsD;IAAtD,iBAAsD;IAAtD,sBAAsD;IAAtD,4DAAsD;IAAtD,kBAAsD;IAAtD,4DAAsD;IAAtD;AAAsD;AAAtD;;IAAA,yBAAsD;AAAA;AAAtD,uCAAA,qBAAsD,EAAA;;AAG1D,iBAAiB;AAEb;IAAA,oBAA8E;IAA9E,mBAA8E;IAA9E,qBAA8E;IAA9E,sBAA8E;IAA9E,uBAA8E;IAA9E,qBAA8E;IAA9E,wBAA8E;IAA9E,kBAA8E;IAA9E,iBAA8E;IAA9E;AAA8E;;AAGlF,qBAAqB;AAEjB;IAAA,oBAAuB;IAAvB;AAAuB;;AAIvB;IAAA,oBAAmB;IAAnB;AAAmB;;AAInB;IAAA,oBAAqB;IAArB;AAAqB;;AAGzB,qBAAqB;AAEjB;IAAA;AAAsB;;AAG1B,iBAAiB;AAEb;IAAA,eAAkF;IAAlF,qBAAkF;IAAlF,kBAAkF;IAAlF,mBAAkF;IAAlF,mBAAkF;IAAlF,sBAAkF;IAAlF,mBAAkF;IAAlF,oBAAkF;IAAlF,gBAAkF;IAAlF,+FAAkF;IAAlF,wDAAkF;IAAlF;AAAkF;;AAIlF;IAAA,kBAA8B;IAA9B,2DAA8B;IAA9B,oBAA8B;IAA9B;AAA8B;;AAI9B;IAAA,kBAAqD;IAArD,4DAAqD;IAArD,oBAAqD;IAArD;AAAqD;;AAArD;IAAA,kBAAqD;IAArD;AAAqD;;AAGzD,kBAAkB;AAEd;IAAA,aAA2F;IAA3F,YAA2F;IAA3F,WAA2F;IAA3F,mBAA2F;IAA3F,uBAA2F;IAA3F,qBAA2F;IAA3F,mBAA2F;IAA3F,oBAA2F;IAA3F,gBAA2F;IAA3F,oBAA2F;IAA3F;AAA2F;;AAG/F,gBAAgB;AAEZ;IAAA,sBAA2D;IAA3D,sBAA2D;IAA3D,iBAA2D;IAA3D,sBAA2D;IAA3D,4DAA2D;IAA3D,kBAA2D;IAA3D,4DAA2D;IAA3D;AAA2D;AAA3D;;IAAA,yBAA2D;AAAA;AAA3D,kCAAA,qBAA2D,EAAA;;AAI3D;IAAA,sBAAkC;IAAlC,sBAAkC;IAAlC;AAAkC;;AAIlC;IAAA,sBAAqC;IAArC,sBAAqC;IAArC;AAAqC;;AAIrC;IAAA,sBAAoC;IAApC,sBAAoC;IAApC;AAAoC;;AAIpC;IAAA,sBAAmC;IAAnC,sBAAmC;IAAnC;AAAmC;;AAGvC,qBAAqB;AAEjB;IAAA,eAAiG;IAAjG,sBAAiG;IAAjG,iBAAiG;IAAjG,sBAAiG;IAAjG,4DAAiG;IAAjG,kBAAiG;IAAjG,4DAAiG;IAAjG,eAAiG;IAAjG,wBAAiG;IAAjG,wDAAiG;IAAjG,0BAAiG;IAAjG;AAAiG;AAAjG;;IAAA,yBAAiG;AAAA;AAAjG,iCAAA,qBAAiG,EAAA;;AAIjG;IAAA,sBAAiC;IAAjC,2DAAiC;IAAjC,+EAAiC;IAAjC,mGAAiC;IAAjC,uGAAiC;IACjC;AADiC;;AAKjC;IAAA,iBAA0C;IAA1C,sBAA0C;IAA1C,2DAA0C;IAA1C,+EAA0C;IAA1C,mGAA0C;IAA1C;AAA0C;;AAG9C,iBAAiB;AAEb;IAAA,sBAAqF;IAArF,iBAAqF;IAArF,sBAAqF;IAArF,4DAAqF;IAArF,kBAAqF;IAArF,4DAAqF;IAArF,eAAqF;IAArF,wBAAqF;IAArF,wDAAqF;IAArF;AAAqF;AAArF;;IAAA,yBAAqF;AAAA;AAArF,mCAAA,qBAAqF,EAAA;AAArF;IAAA,+EAAqF;IAArF,mGAAqF;IAArF,uGAAqF;IAIrF;AAJqF;;AAOzF,kBAAkB;AAEd;IAAA,iBAAgE;IAAhE,sBAAgE;IAAhE,4DAAgE;IAAhE,kBAAgE;IAAhE,4DAAgE;IAAhE,oBAAgE;IAAhE;AAAgE;;AAIhE;IAAA,iBAA0D;IAA1D,sBAA0D;IAA1D,4DAA0D;IAA1D,kBAA0D;IAA1D,4DAA0D;IAA1D,oBAA0D;IAA1D;AAA0D;;AAI1D;IAAA,iBAAoD;IAApD,sBAAoD;IAApD,4DAAoD;IAApD,kBAAoD;IAApD,4DAAoD;IAApD,oBAAoD;IAApD;AAAoD;;AAIpD;IAAA,iBAAuD;IAAvD,sBAAuD;IAAvD,4DAAuD;IAAvD,kBAAuD;IAAvD,4DAAuD;IAAvD,oBAAuD;IAAvD;AAAuD;;AAG3D,wBAAwB;AACxB;IACI,4DAA4D;AAChE;;AAEA;IACI,4DAA4D;AAChE;;AAEA,uBAAuB;AAEnB;IAAA,WAAqB;IAArB,mBAAqB;IAArB;AAAqB;;AAIrB;IAAA,wBAA8H;IAA9H,sBAA8H;IAA9H,4DAA8H;IAA9H,kBAA8H;IAA9H,4DAA8H;IAA9H,kBAA8H;IAA9H,mBAA8H;IAA9H,oBAA8H;IAA9H,uBAA8H;IAA9H,gBAA8H;IAA9H,kBAA8H;IAA9H,iBAA8H;IAA9H,gBAA8H;IAA9H,yBAA8H;IAA9H,sBAA8H;IAA9H,oBAA8H;IAA9H;AAA8H;;AAA9H,qCAAA,qBAA8H,EAAA;;AAI9H;IAAA,wBAA0C;IAA1C,sBAA0C;IAA1C,4DAA0C;IAA1C,kBAA0C;IAA1C,mBAA0C;IAA1C,oBAA0C;IAA1C;AAA0C;;AAA1C,qCAAA,qBAA0C,EAAA;;AAI1C;IAAA,kBAAkB;IAAlB;AAAkB;;AAGtB,0BAA0B;AAEtB;IAAA,kBAA4B;IAA5B,0DAA4B;IAA5B,oBAA4B;IAA5B;AAA4B;;AAI5B;IAAA,kBAA+B;IAA/B,2DAA+B;IAA/B,oBAA+B;IAA/B;AAA+B;;AAI/B;IAAA,kBAA8B;IAA9B,2DAA8B;IAA9B,oBAA8B;IAA9B;AAA8B;;AAI9B;IAAA,kBAA6B;IAA7B,2DAA6B;IAA7B,oBAA6B;IAA7B;AAA6B;;AAGjC,sBAAsB;AAElB;IAAA,sBAAqE;IAArE,iBAAqE;IAArE,oCAAqE;IAArE,wCAAqE;IAArE,8BAAqE;IAArE;AAAqE;;AAGzE,kBAAkB;AAClB;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,iDAAiD;IACjD,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,2CAA2C;AAC3C;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,wCAAwC;AAEpC;IAAA,kBAAmB;IAAnB;AAAmB;;AAInB;IAAA,sBAAoC;IAApC,yDAAoC;IAApC,kBAAoC;IAApC;AAAoC;;AAQpC;;;;;IAAA,oBAAiB;IAAjB;AAAiB;;AAKjB;;IAAA,oBAAqB;IAArB;AAAqB;;AAIrB;IAAA,sBAAoC;IAApC,yDAAoC;IAApC,kBAAoC;IAApC;AAAoC;;AAIpC;IAAA,oBAAiB;IAAjB;AAAiB;;AAIjB;IAAA,sBAAoC;IAApC,yDAAoC;IAApC,kBAAoC;IAApC;AAAoC;;AAIpC;IAAA,sBAAmD;IAAnD,yDAAmD;IAAnD,kBAAmD;IAAnD,yDAAmD;IAAnD,oBAAmD;IAAnD;AAAmD;;AAInD;IAAA,sBAAsC;IAAtC,yDAAsC;IAAtC,oBAAsC;IAAtC;AAAsC;;AAItC;IAAA;AAAsB;;AAItB;IAAA,sBAAoC;IAApC,yDAAoC;IAApC,kBAAoC;IAApC;AAAoC;;AAIpC;IAAA,sBAAoC;IAApC,yDAAoC;IAApC,kBAAoC;IAApC;AAAoC;;AAIpC;IAAA,oBAAqB;IAArB;AAAqB;;AAIrB;IAAA,sBAAoC;IAApC,yDAAoC;IAApC,kBAAoC;IAApC;AAAoC;;AAIpC;IAAA,iCAA0C;IAA1C;AAA0C;;AAI1C;IAAA,kBAAqD;IAArD,yDAAqD;IAArD,oBAAqD;IAArD;AAAqD;;AAArD;IAAA,kBAAqD;IAArD;AAAqD;;AAGzD,8CAA8C;AAC9C,gDAAgD,cAAc,EAAE;AAChE,gDAAgD,cAAc,EAAE;AAChE,gDAAgD,cAAc,EAAE;AAChE,gDAAgD,cAAc,EAAE;AAChE,gDAAgD,cAAc,EAAE;;AAEhE;;IAEI,yBAAyB;AAC7B;;AAEA,wCAAwC,qBAAqB,EAAE;AAC/D,wCAAwC,qBAAqB,EAAE;;AAE/D,0BAA0B;AAC1B;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;AAC7B","sourcesContent":["/* App-specific styles */\n.App {\n    min-height: 100vh;\n}\n\n/* Sidebar */\n.sidebar {\n    @apply bg-gradient-to-b from-[#1a0a2e] via-[#2d1b4e] to-[#1a0a2e] text-white min-h-screen w-64 fixed left-0 top-0;\n}\n\n.sidebar-link {\n    @apply flex items-center gap-3 px-4 py-3 text-white/70 hover:bg-white/10 hover:text-white transition-colors rounded-xl;\n}\n\n.sidebar-link.active {\n    @apply bg-[#F26522] text-white shadow-lg;\n    box-shadow: 0 4px 15px rgba(242, 101, 34, 0.3);\n}\n\n/* Main content */\n.main-content {\n    @apply ml-64 min-h-screen bg-slate-50;\n}\n\n/* Header (page subheader; sits below global SiteHeader) */\n.header {\n    @apply sticky top-16 z-10 border-b border-slate-200 bg-white px-6 py-4;\n}\n\n/* KPI cards */\n.kpi-card {\n    @apply bg-white border border-slate-200 rounded-xl p-5 hover:shadow-md transition-shadow;\n}\n\n.kpi-value {\n    @apply text-2xl font-bold text-slate-900;\n}\n\n.kpi-label {\n    @apply text-sm text-slate-500 mt-1;\n}\n\n/* Chart containers */\n.chart-container {\n    @apply bg-white border border-slate-200 rounded-xl p-6;\n}\n\n/* Badge styles */\n.badge {\n    @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium;\n}\n\n/* Trend indicators */\n.trend-up {\n    @apply text-emerald-600;\n}\n\n.trend-down {\n    @apply text-red-600;\n}\n\n.trend-neutral {\n    @apply text-slate-500;\n}\n\n/* Table responsive */\n.table-responsive {\n    @apply overflow-x-auto;\n}\n\n/* Filter pills */\n.filter-pill {\n    @apply px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-colors;\n}\n\n.filter-pill.active {\n    @apply bg-[#F26522] text-white;\n}\n\n.filter-pill:not(.active) {\n    @apply bg-slate-100 text-slate-600 hover:bg-slate-200;\n}\n\n/* Score circles */\n.score-circle {\n    @apply w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-sm;\n}\n\n/* Alert cards */\n.alert-card {\n    @apply bg-white border border-slate-200 rounded-xl p-4 mb-3;\n}\n\n.alert-card.critical {\n    @apply border-l-4 border-l-red-500;\n}\n\n.alert-card.high {\n    @apply border-l-4 border-l-orange-500;\n}\n\n.alert-card.medium {\n    @apply border-l-4 border-l-amber-500;\n}\n\n.alert-card.low {\n    @apply border-l-4 border-l-blue-500;\n}\n\n/* Role card styles */\n.role-card {\n    @apply bg-white border border-slate-200 rounded-xl p-6 cursor-pointer transition-all duration-200;\n}\n\n.role-card:hover {\n    @apply border-[#F26522] shadow-lg;\n    transform: translateY(-4px);\n}\n\n.role-card.selected {\n    @apply border-[#F26522] border-2 shadow-lg;\n}\n\n/* Pillar cards */\n.pillar-card {\n    @apply bg-white border border-slate-200 rounded-xl p-6 hover:shadow-lg transition-all;\n}\n\n.pillar-card:hover {\n    transform: translateY(-2px);\n}\n\n/* Status badges */\n.status-on-track {\n    @apply bg-emerald-100 text-emerald-700 border border-emerald-200;\n}\n\n.status-at-risk {\n    @apply bg-amber-100 text-amber-700 border border-amber-200;\n}\n\n.status-delayed {\n    @apply bg-red-100 text-red-700 border border-red-200;\n}\n\n.status-planned {\n    @apply bg-blue-100 text-blue-700 border border-blue-200;\n}\n\n/* Progress bar custom */\n.progress-saffron {\n    background: linear-gradient(90deg, #F26522 0%, #FF8A50 100%);\n}\n\n.progress-blue {\n    background: linear-gradient(90deg, #1E3A8A 0%, #3B82F6 100%);\n}\n\n/* Data table styling */\n.data-table {\n    @apply w-full text-sm;\n}\n\n.data-table th {\n    @apply bg-slate-50 text-slate-600 font-semibold uppercase tracking-wider text-xs px-4 py-3 text-left border-b border-slate-200;\n}\n\n.data-table td {\n    @apply px-4 py-3 border-b border-slate-100;\n}\n\n.data-table tbody tr:hover {\n    @apply bg-slate-50;\n}\n\n/* Alert severity badges */\n.severity-critical {\n    @apply bg-red-500 text-white;\n}\n\n.severity-high {\n    @apply bg-orange-500 text-white;\n}\n\n.severity-medium {\n    @apply bg-amber-500 text-white;\n}\n\n.severity-low {\n    @apply bg-blue-500 text-white;\n}\n\n/* Glass card effect */\n.glass-card {\n    @apply bg-white/80 backdrop-blur-lg border border-white/20 rounded-xl;\n}\n\n/* Gradient text */\n.gradient-text {\n    background: linear-gradient(135deg, #F26522 0%, #FF8A50 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n/* Leaflet map overrides */\n.district-tooltip {\n    background: white !important;\n    border: 1px solid #E2E8F0 !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;\n    padding: 8px 12px !important;\n}\n\n.district-tooltip::before {\n    border-top-color: #E2E8F0 !important;\n}\n\n.leaflet-container {\n    font-family: 'Outfit', sans-serif;\n    background: #FFFFFF !important;\n}\n\n.leaflet-control-zoom a {\n    color: #1E3A8A !important;\n    border-color: #E2E8F0 !important;\n}\n\n.leaflet-control-zoom a:hover {\n    background-color: #F8FAFC !important;\n}\n\n/* District label and star marker styling */\n.district-label-icon {\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.star-marker {\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n/* ============ DARK MODE ============ */\n.dark .main-content {\n    @apply bg-slate-900;\n}\n\n.dark .header {\n    @apply bg-slate-800 border-slate-700;\n}\n\n.dark .header h1,\n.dark .main-content h1,\n.dark .main-content h2,\n.dark .main-content h3,\n.dark .main-content h4 {\n    @apply text-white;\n}\n\n.dark .header p,\n.dark .kpi-label {\n    @apply text-slate-400;\n}\n\n.dark .kpi-card {\n    @apply bg-slate-800 border-slate-700;\n}\n\n.dark .kpi-value {\n    @apply text-white;\n}\n\n.dark .chart-container {\n    @apply bg-slate-800 border-slate-700;\n}\n\n.dark .data-table th {\n    @apply bg-slate-800 text-slate-300 border-slate-700;\n}\n\n.dark .data-table td {\n    @apply border-slate-700 text-slate-300;\n}\n\n.dark .data-table tbody tr:hover {\n    @apply bg-slate-700/50;\n}\n\n.dark .role-card {\n    @apply bg-slate-800 border-slate-700;\n}\n\n.dark .pillar-card {\n    @apply bg-slate-800 border-slate-700;\n}\n\n.dark .pillar-card p, .dark .pillar-card span {\n    @apply text-slate-300;\n}\n\n.dark .alert-card {\n    @apply bg-slate-800 border-slate-700;\n}\n\n.dark .glass-card {\n    @apply bg-slate-800/80 border-slate-700/50;\n}\n\n.dark .filter-pill:not(.active) {\n    @apply bg-slate-700 text-slate-300 hover:bg-slate-600;\n}\n\n/* Dark text overrides for main content area */\n.dark .main-content [class*=\"text-slate-900\"] { color: #F8FAFC; }\n.dark .main-content [class*=\"text-slate-800\"] { color: #F1F5F9; }\n.dark .main-content [class*=\"text-slate-700\"] { color: #CBD5E1; }\n.dark .main-content [class*=\"text-slate-600\"] { color: #94A3B8; }\n.dark .main-content [class*=\"text-slate-500\"] { color: #94A3B8; }\n\n.dark .main-content > div > .bg-white,\n.dark .main-content .bg-white:not(.leaflet-container *) {\n    background-color: #1E293B;\n}\n\n.dark .main-content .border-slate-200 { border-color: #334155; }\n.dark .main-content .border-slate-100 { border-color: #334155; }\n\n/* Dark mode for leaflet */\n.dark .leaflet-container {\n    background: #0F172A !important;\n}\n\n.dark .district-tooltip {\n    background: #1E293B !important;\n    border-color: #334155 !important;\n    color: #E2E8F0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
